import { CACHE_TAG } from 'enums';

import apiRoutes from 'router/routes/ApiRoutes';

import { apiContainer } from 'store';

import { selectDataFromResponse } from 'utils/objects';

import { IBorrowerConfigurationResponse } from './types';

export const successorBorrowerConfigurationApi = apiContainer.injectEndpoints({
  endpoints: builder => ({
    getSuccessorBorrowerConfiguration: builder.query<IBorrowerConfigurationResponse, void>({
      query: () => ({
        url: apiRoutes.successorBorrowersConfigurationPath(),
        method: 'GET',
      }),
      transformResponse: selectDataFromResponse,
      providesTags: [CACHE_TAG.successorBorrowerConfiguration],
    }),
  }),
});

export const { useGetSuccessorBorrowerConfigurationQuery } = successorBorrowerConfigurationApi;
